import React from 'react';
import successStories1 from '../images/successstories1-image.jpg';
import successStories2 from '../images/successstories2-image.jpeg';
import './Stories.css';

const Stories = () => {
  const stories = [
    {
      image: successStories1,
      title: 'From Village School to Engineering College',
      description: 'Santhosh journey from a rural government school to becoming a engineer, supported by Ezhuthaani.org scholarships.'
    },
    {
      image: successStories2,
      title: 'Breaking the Cycle of Poverty',
      description: 'How Hari became the first in his family to graduate college with our support and mentorship.'
    }
  ];

  return (
    <section className="stories-preview" id="stories">
      <div className="container">
        <h2>Success Stories</h2>
        <div className="stories-grid">
          {stories.map((story, index) => (
            <article key={index} className="story-card">
              <img src={story.image} alt="Success story" />
              <div className="story-content">
                <h3>{story.title}</h3>
                <p>{story.description}</p>
                <a href="#" className="read-more">Read More</a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stories;